import "@app/App.css";
import { Notification } from "@comps/ui/notification";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { FullRightAccess, ViewRightType, hasGlobalRightAccess } from "@dto/Users";
import { columnAggregation } from "@dto/fields";
import { Summary } from "@dto/views";
import { getFieldByPathKeys, getPathKeys } from "@utils/model";
import { isSummable } from "@utils/summaries";
import { TW_ObjectHeaderButtonTitle, TW_ObjectModelViewHeaderButton, TW_ObjectModelViewHeaderIcon } from "@utils/twClasses";
import { Sigma } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore, useModelStore, useUserStore } from "src/store";
import SummaryEditor from "./SummaryEditor";

function SummaryButton() {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const selectedView = useModelStore((state) => state.selectedView);
  const selectedObjectInfos = useModelStore((state) => state.selectedObjectInfos);
  const { t } = useTranslation();
  const user = useUserStore((state) => state.user);
  const userRole = useModelStore((state) => state.userRole);
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);

  const fields = selectedObjectInfos?.fields || null;
  const fieldByKeys = useModelStore(state => state.fieldByKeys);
  const relationByKeys = useModelStore(state => state.relationByKeys);
  const fieldByPathKeys = getFieldByPathKeys(selectedObjectInfos, selectedObjectInfos?.fields || [], relationByKeys, fieldByKeys);

  // Summability depends on the column aggregation of the view (a text column
  // counted displays numbers): resolve it per path key like the grid does
  const viewAggregations = selectedView?.aggregations;
  const summaries = selectedView?.summaries?.filter((summary: Summary) => {
    const field = fieldByPathKeys.get(summary.pathKey);
    return isSummable(field, columnAggregation(field, viewAggregations, summary.pathKey));
  });
  const numberOfSummaries = summaries?.length || 0;

  const pathKeys = getPathKeys(selectedObjectInfos, fields, relationByKeys, fieldByKeys, false);
  const hasSummableField = (fields || []).some((field, index) => isSummable(field, columnAggregation(field, viewAggregations, pathKeys[index])));
  const hasFullAccess = selectedView?.ownerKey === user?._key || hasGlobalRightAccess(user, userRole, ViewRightType, FullRightAccess, selectedView?._key);
  const isDisabled = !hasSummableField || !rowActionsEnabled;
  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger disabled={isDisabled} className={TW_ObjectModelViewHeaderButton + (isDisabled ? " opacity-50 cursor-not-allowed" : " opacity-100 cursor-default")}>
        <div className="flex flex-row justify-start items-center relative">
          <Sigma className={TW_ObjectModelViewHeaderIcon} />
          {numberOfSummaries > 0 && <Notification number={numberOfSummaries} />}
        </div>
        <span className={TW_ObjectHeaderButtonTitle}>{t('object.header.button.summary.title')}</span>
      </PopoverTrigger>
      <PopoverContent className="w-max p-2">
        <SummaryEditor summaries={summaries || []} disabled={!hasFullAccess} onClose={() => setIsPopoverOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default SummaryButton;
